import styled from 'styled-components';

export const SPopoverContentWrapper = styled.div<{ maxWidth?: number }>`
  ${({ maxWidth }) => maxWidth && `max-width: ${maxWidth}px`}
`;
